export const BodyStyle = {
  None: 0,
  Compact: 1,
  Sedan: 2,
  Hatchback: 3,
  CUV: 4,
  SUV: 5,
  Minivan: 6,
  Pickup: 7,
  Van: 8,
  Commercial: 9,
  Convertible: 10,
}

export const BodyStyles = [
  { label: 'CUV', value: BodyStyle.CUV },
  { label: 'Compact', value: BodyStyle.Compact },
  { label: 'Convertible', value: BodyStyle.Convertible },
  { label: 'Hatchback', value: BodyStyle.Hatchback },
  { label: 'Minivan', value: BodyStyle.Minivan },
  { label: 'Pickup', value: BodyStyle.Pickup },
  { label: 'SUV', value: BodyStyle.SUV },
  { label: 'Sedan', value: BodyStyle.Sedan },
  { label: 'Commercial', value: BodyStyle.Commercial },
  { label: 'Van', value: BodyStyle.Van },
]

export const NormalizedBodyStyles = {
  1: 'Compact',
  2: 'Sedan',
  3: 'Hatchback',
  4: 'CUV',
  5: 'SUV',
  6: 'Minivan',
  7: 'Pickup',
  8: 'Van',
  9: 'Commercial',
  10: 'Convertible',
}
